import React from 'react'
import { Text } from '@/style-guide'
import { CheckSquareOutlined } from '@ant-design/icons'
import { mergeArray } from '@/utils/mergeArray'
import { Tabs } from 'antd'
import { useSelector } from 'react-redux'
export const QuestionsView = ({
  questions,
  tripQuestions,
  guests = [],
  memberInfo,
}) => {
  const { currentUser } = useSelector((state) => state.auth)
  let ques = []
  if (Array.isArray(tripQuestions)) {
    const tripQuestionsCopy = JSON.parse(JSON.stringify(tripQuestions))
    ques = mergeArray(
      tripQuestionsCopy,
      Array.isArray(questions) ? questions : [],
      'questionText',
      ['answer']
    )
  }
  let updatedGuests = []
  if (guests?.length > 0) {
    updatedGuests = guests?.map((guest) => {
      if (Array.isArray(tripQuestions)) {
        const tripQuestionsCopy = JSON.parse(JSON.stringify(tripQuestions))
        guest['guest_questions'] = mergeArray(
          tripQuestionsCopy,
          Array.isArray(guest.guest_questions) ? guest.guest_questions : [],
          'questionText',
          ['answer']
        )
      }
      return guest
    })
  }
  return (
    <div>
      {ques?.length > 0 && (
        <Tabs defaultActiveKey="yourself">
          <Tabs.TabPane
            tab={currentUser?._id == memberInfo._id ? 'Yourself' : 'Main attendee'}
            key="yourself"
          >
            {ques.map((question, index) => (
              question.answer &&
              <div className='question-table-container' key={question.id}>
                <div className='number-of-question'>Q{index + 1}</div>
                <div className='question-answer-container'>
                  <Text size={14} weight="700">
                    {question.questionText}
                  </Text>
                  <br />
                  <Text size={14}>
                    {question.type == 'MultiChoice' && question.answer ? (
                      <div>
                        {question?.answer?.map((a) => (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <CheckSquareOutlined />{' '}
                            <span style={{ marginLeft: '10px' }}>{a}</span>
                          </div>
                        ))}
                      </div>
                    ) : question.type == 'UploadFile' && question.answer ? (
                      <div>
                        <a href={question.answer}>
                          {question?.answer?.split('/')?.slice(-1)}
                        </a>
                      </div>
                    ) : question.answer ? (
                      question?.answer || ''
                    ) : (
                      <span style={{ fontStyle: 'italic', color: 'lightgray' }}>
                        unanswered
                      </span>
                    )}
                  </Text>
                </div>
              </div>
            ))}
          </Tabs.TabPane>
          {updatedGuests?.map((guest) => (
            <Tabs.TabPane tab={guest.name} key={guest.id}>
              {guest?.guest_questions?.map((question, index) => (
                question.answer &&
                <div
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                  }}
                  key={question.id}
                >
                  Q{index + 1}
                  <div style={{ marginLeft: '20px' }}>
                    <Text size={14} weight="700">
                      {question.questionText}
                    </Text>
                    <br />
                    <Text size={14}>
                      {question.type == 'MultiChoice' && question.answer ? (
                        <div>
                          {question?.answer?.map((a) => (
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <CheckSquareOutlined />{' '}
                              <span style={{ marginLeft: '10px' }}>{a}</span>
                            </div>
                          ))}
                        </div>
                      ) : question.type == 'UploadFile' && question.answer ? (
                        <div>
                          <a href={question.answer}>
                            {question?.answer?.split('/')?.slice(-1)}
                          </a>
                        </div>
                      ) : question.answer ? (
                        question?.answer || ''
                      ) : (
                        <span
                          style={{ fontStyle: 'italic', color: 'lightgray' }}
                        >
                          unanswered
                        </span>
                      )}
                    </Text>
                  </div>
                </div>
              ))}
            </Tabs.TabPane>
          ))}
        </Tabs>
      )}
    </div>
  )
}
